export default __webpack_public_path__ + "static/media/loader-pt2.167990b3.svg";